import styled from '@emotion/styled';
import {
  APPLE_STORE_LINK,
  AngeplusLightLogo,
  ButtonNormalPrimarySmall,
  ButtonNormalPrimarySmallCompact,
  ButtonNormalSecondarySmall,
  ButtonNormalSecondarySmallCompact,
  CloseOutlineMediumIcon,
  PLAY_STORE_LINK,
  token,
} from '@angeplus/prever-component-lib';
import { LinkWrapper } from '@angeplus/prever-component-lib/nextjs';
import { useEffect, useState } from 'react';

import { useOSInfo } from '../../../install-app/install-app.store';
import { AUTH } from '../../../routes';

export const HubHeader = () => {
  const { isIOS } = useOSInfo();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    if (isMenuOpen) {
      const originalOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';

      return () => {
        document.body.style.overflow = originalOverflow || '';
      };
    }
  }, [isMenuOpen]);

  const handleDownloadApp = () => {
    if (isIOS) {
      window.location.assign(APPLE_STORE_LINK);
    } else {
      window.location.assign(PLAY_STORE_LINK);
    }
    setIsMenuOpen(false);
  };

  const handleNavClick = () => {
    setIsMenuOpen(false);
  };

  return (
    <HeaderContainer>
      <HeaderContent>
        <AngeplusLightLogo />

        <NavLinks>
          <NavLink href="#inicio">Início</NavLink>
          <NavLink href="#beneficios">Benefícios</NavLink>
          <NavLink href="#planos">Planos</NavLink>
          <NavLink href="#servicos">Serviços</NavLink>
          <NavLink href="#depoimentos">Depoimentos</NavLink>
        </NavLinks>

        <HeaderButtons>
          <ButtonWrapper onClick={handleDownloadApp}>
            <ButtonNormalPrimarySmallCompact>
              Baixar o app Angeplus
            </ButtonNormalPrimarySmallCompact>
          </ButtonWrapper>

          <LinkWrapper href={AUTH}>
            <ButtonNormalSecondarySmallCompact className="button_secondary_alt">
              Área do cliente
            </ButtonNormalSecondarySmallCompact>
          </LinkWrapper>
        </HeaderButtons>

        <HamburgerButton onClick={() => setIsMenuOpen(true)}>
          <HamburgerIcon>
            <span />
            <span />
            <span />
          </HamburgerIcon>
        </HamburgerButton>
      </HeaderContent>

      <MobileMenuOverlay
        isOpen={isMenuOpen}
        onClick={() => setIsMenuOpen(false)}
      />

      <MobileMenu isOpen={isMenuOpen}>
        <MobileMenuHeader>
          <MobileMenuLogo>
            <AngeplusLightLogo height={40} width={100} />
          </MobileMenuLogo>
          <CloseButton onClick={() => setIsMenuOpen(false)}>
            <CloseOutlineMediumIcon color="#ffffff" />
          </CloseButton>
        </MobileMenuHeader>

        <MobileMenuContent>
          <MobileNavLinks>
            <MobileNavLink href="#inicio" onClick={handleNavClick}>
              Início
            </MobileNavLink>
            <MobileNavLink href="#beneficios" onClick={handleNavClick}>
              Benefícios
            </MobileNavLink>
            <MobileNavLink href="#planos" onClick={handleNavClick}>
              Planos
            </MobileNavLink>
            <MobileNavLink href="#servicos" onClick={handleNavClick}>
              Serviços
            </MobileNavLink>
            <MobileNavLink href="#depoimentos" onClick={handleNavClick}>
              Depoimentos
            </MobileNavLink>
          </MobileNavLinks>

          <MobileMenuButtons>
            <ButtonWrapper onClick={handleDownloadApp}>
              <ButtonNormalPrimarySmall>
                Baixar o app Angeplus
              </ButtonNormalPrimarySmall>
            </ButtonWrapper>

            <LinkWrapper href={AUTH}>
              <ButtonNormalSecondarySmall className="button_secondary_alt">
                Área do cliente
              </ButtonNormalSecondarySmall>
            </LinkWrapper>
          </MobileMenuButtons>
        </MobileMenuContent>
      </MobileMenu>
    </HeaderContainer>
  );
};

const TRANSITION = '0.2s ease';
const MOBILE_BREAKPOINT = '1024px';
const WHITE_OVERLAY_10 = 'rgba(255, 255, 255, 0.1)';
const WHITE_OVERLAY_12 = 'rgba(255, 255, 255, 0.12)';

const HeaderContainer = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  background-color: ${token.colors.solidAngeplusForeground};
  padding: ${token.spacing.spacingMedium} ${token.spacing.spacingMedium};

  @media (min-width: 768px) {
    padding: ${token.spacing.spacingMedium} ${token.spacing.spacingXxLarge};
  }
`;

const HeaderContent = styled.div`
  max-width: 1312px;
  margin: 0 auto;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;

  > svg {
    flex-shrink: 0;
    height: 48px;
    width: 120px;
    margin-right: ${token.spacing.spacingXxLarge};
  }

  @media (max-width: 768px) {
    > svg {
      height: 40px;
      width: 100px;
    }
  }
`;

const NavLinks = styled.nav`
  display: flex;
  gap: ${token.spacing.spacingLarge};
  flex: 1;

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    display: none;
  }
`;

const NavLink = styled.a`
  color: #ffffff;
  text-decoration: none;
  font-size: 16px;
  font-weight: 500;
  font-family: ${token.typography.fontFamily01};
  padding: ${token.spacing.spacingXSmall} 0;
`;

const HeaderButtons = styled.div`
  display: flex;
  gap: ${token.spacing.spacingMedium};

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    display: none;
  }
`;

const ButtonWrapper = styled.div`
  cursor: pointer;
  white-space: nowrap;
`;

const InteractiveButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  border-radius: ${token.borderRadius.borderRadiusMedium};
  transition: background-color ${TRANSITION};

  &:hover {
    background-color: ${WHITE_OVERLAY_10};
  }

  &:active {
    background-color: ${WHITE_OVERLAY_12};
  }
`;

const HamburgerButton = styled(InteractiveButton)`
  display: none;
  padding: ${token.spacing.spacingXSmall};
  z-index: 101;

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

const HamburgerIcon = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  width: 24px;
  height: 18px;

  span {
    display: block;
    width: 100%;
    height: 2.5px;
    background-color: #ffffff;
    border-radius: 2px;
  }
`;

const MobileMenuOverlay = styled.div<{ isOpen: boolean }>`
  display: none;

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    display: ${({ isOpen }) => (isOpen ? 'block' : 'none')};
    position: fixed;
    inset: 0;
    background-color: rgba(0, 0, 0, 0.6);
    backdrop-filter: blur(4px);
    -webkit-backdrop-filter: blur(4px);
    z-index: 199;
    opacity: ${({ isOpen }) => (isOpen ? 1 : 0)};
    transition: opacity 0.3s ease;
  }
`;

const MobileMenu = styled.div<{ isOpen: boolean }>`
  display: none;

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    display: flex;
    flex-direction: column;
    position: fixed;
    top: 0;
    right: ${({ isOpen }) => (isOpen ? '0' : '-100%')};
    width: 100%;
    max-width: 380px;
    height: 100vh;
    background-color: ${token.colors.solidAngeplusForeground};
    box-shadow: -4px 0 24px rgba(0, 0, 0, 0.3);
    z-index: 200;
    transition: right 0.35s ease;
    overflow: hidden;
  }
`;

const MobileMenuHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${token.spacing.spacingLarge} ${token.spacing.spacingMedium};
  border-bottom: 1px solid ${WHITE_OVERLAY_12};
  flex-shrink: 0;
  background-color: rgba(255, 255, 255, 0.02);
`;

const MobileMenuLogo = styled.div`
  display: flex;
  align-items: center;
`;

const CloseButton = styled(InteractiveButton)`
  padding: ${token.spacing.spacingXSmall};
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background: ${WHITE_OVERLAY_10};
  transition: all ${TRANSITION};

  &:hover {
    background: rgba(255, 255, 255, 0.2);
    transform: scale(1.05);
  }

  &:active {
    transform: scale(0.95);
  }
`;

const MobileMenuContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.2);
    border-radius: 2px;

    &:hover {
      background: rgba(255, 255, 255, 0.3);
    }
  }
`;

const MobileNavLinks = styled.nav`
  display: flex;
  flex-direction: column;
  padding: ${token.spacing.spacingMedium} 0;
  flex: 1;
`;

const MobileNavLink = styled(LinkWrapper)`
  color: #ffffff;
  text-decoration: none;
  font-size: 17px;
  font-weight: 500;
  font-family: ${token.typography.fontFamily01};
  padding: ${token.spacing.spacingMedium} ${token.spacing.spacingLarge};
  margin: 0 ${token.spacing.spacingSmall};
  border-radius: ${token.borderRadius.borderRadiusMedium};
  transition: all ${TRANSITION};
  position: relative;
  display: flex;
  align-items: center;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 3px;
    height: 0;
    background-color: ${token.colors.solidAngeplusPrimaryPure};
    border-radius: 0 2px 2px 0;
    transition: height ${TRANSITION};
  }

  &:hover {
    background-color: rgba(255, 255, 255, 0.08);
    color: ${token.colors.solidAngeplusPrimaryPure};
    padding-left: ${token.spacing.spacingXLarge};

    &::before {
      height: 24px;
    }
  }

  &:active {
    background-color: ${WHITE_OVERLAY_12};
    transform: scale(0.98);
  }
`;

const MobileMenuButtons = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${token.spacing.spacingMedium};
  padding: ${token.spacing.spacingLarge} ${token.spacing.spacingMedium};
  border-top: 1px solid ${WHITE_OVERLAY_12};
  background-color: rgba(255, 255, 255, 0.02);
  flex-shrink: 0;
`;
